import { Spin } from "antd";
import React from "react";

const Loading = ({ children, isLoading }) => {
  return (
    <>
      <Spin
        tip="Loading..."
        spinning={isLoading}
        size="large"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {children}
      </Spin>
    </>
  );
};

export default Loading;
